import React, { Component } from "react";





class BirthdayItemField extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClickField = this.onClickField.bind(this);
  }



  // ===============================================================================================
  onClickField(e) {
    e.preventDefault();
    this.props.handleClick(this.props.type);
  }



  // ===============================================================================================
  getSuffix() {
    if (this.props.type === "age") {
      let num = parseInt(this.props.value, 10);  // Base 10 radix
      return (typeof num === "number") ? this.getOrdinalSuffix(num) : "";
    }
    else {
      if (this.props.value.endsWith('s') || this.props.value.endsWith('S')) {
          return "’";
      }
      return "’s";
    }
  }



  // ===============================================================================================
  getOrdinalSuffix(num) {
    // https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) { return "st"; }
    if (j === 2 && k !== 12) { return "nd"; }
    if (j === 3 && k !== 13) { return "rd"; }
    return "th";
  }



  // ===============================================================================================
  render() {
    return (
      <div className="item-placeholders__item" onClick={this.onClickField}>

        <span className={"item-placeholders__item--text" +
          ((this.props.value) ? " filled" : "")}>
          {(this.props.value) ? this.props.value : this.props.default}
        </span>

        <span className="item-placeholders__item--suffix">
          {this.getSuffix()}
        </span>

      </div>
    );
  }

}



export default BirthdayItemField
